'use strict';

const commonWorkpackageStoreSchema = require('./workpackage-stores-shared');

module.exports = {
  ...commonWorkpackageStoreSchema,
};
